import { useNavigate } from "react-router-dom";
import BackButton from "../../Components/BackButton";
import { Success, Error } from "../../Components/Modal";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { createCancellationReason } from "../../Services/CancellationReason";
import CancellationReasonForm from "./Components/CancellationReasonForm";
import "../CMSManagement/CMSManagement.css";
import "../../styles/PremiumCardPages.css";

export default function AddCancellationReason() {
    const navigate = useNavigate();

    const { register, handleSubmit, formState: { errors }, control } = useForm({
        defaultValues: {
            status: "true",
            userType: "user",
        },
    });

    const { mutate, isLoading } = useMutation(createCancellationReason, {
        onSuccess: (res) => {
            Success("Reason Created", res.data?.message || "Cancellation reason has been added successfully.");
            navigate("/cancellation-management");
        },
        onError: (err) => {
            Error(err?.response?.data?.message || "Failed to create reason.");
        },
    });

    return (
        <div className="app-content content pform-page">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="add-cancellation-reason">
                        <div className="user-details-wrapper">
                            <div className="pform-page-header">
                                <div className="pform-page-header__row">
                                    <BackButton />
                                    <h1 className="pform-page-header__title">Add Cancellation Reason</h1>
                                </div>
                                <p className="pform-page-header__subtitle">
                                    Create a new reason for users or drivers to cancel bookings
                                </p>
                            </div>

                            <div className="pform-shell">
                                <CancellationReasonForm
                                    register={register}
                                    handleSubmit={handleSubmit}
                                    errors={errors}
                                    control={control}
                                    onSubmit={(data) => mutate(data)}
                                    isLoading={isLoading}
                                />
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </div>
    );
}
